import { formatPot } from './format';
import { PlayerResultRow } from './PlayerResultRow';
import { GameType, PotSnapshot } from './types';

import styles from './HandHistory.module.scss';

export const PotBreakdown = ({
  pot,
  gameType,
  viewerSeat,
  avatarBySeat,
  boardOf
}: {
  pot: PotSnapshot;
  gameType: GameType;
  viewerSeat?: number;
  avatarBySeat?: Record<number, string | undefined>;
  /** The board that paid a row: its run's on a multi-run hand. */
  boardOf?: (run?: number) => string[] | undefined;
}) => (
  <section className={styles.potBreakdown}>
    <header className={styles.potHeader}>
      <span>{pot.name}</span>
      <strong>{formatPot(pot.amount, gameType)}</strong>
    </header>

    {pot.awards.map((award) => (
      <div className={styles.potAward} key={`${pot.potId}-${award.handType}`}>
        <div className={styles.potAwardHeader}>
          <span>{award.handType === 'Hi' ? 'High' : 'Low'}</span>
          <strong>{formatPot(award.amount, gameType)}</strong>
        </div>
        <div className={styles.playerRows}>
          {[...award.players]
            .sort((a, b) => Number(b.isWinner) - Number(a.isWinner) || a.seat - b.seat)
            .map((player) => (
              <PlayerResultRow
                key={`${pot.potId}-${award.handType}-${player.playerId}-${player.seat}`}
                player={player}
                gameType={gameType}
                isViewer={player.seat === viewerSeat}
                fallbackAvatar={avatarBySeat?.[player.seat]}
                board={boardOf?.(player.run)}
              />
            ))}
        </div>
      </div>
    ))}

    {pot.noLowQualified && (
      <div className={styles.noLowQualified}>
        <span>Low</span>
        <strong>No Low qualified</strong>
      </div>
    )}
  </section>
);
